
import { Component, Vue, Prop } from 'vue-property-decorator';

import DiamondIcon from '@/assets/icons/Diamond.vue';
import CreditsIcon from '@/assets/icons/Credits.vue';
import InformationIcon from '@/assets/icons/Information.vue';

import ActiveModal from '@/share/Util/ActiveModal';

@Component({
  components: {
    DiamondIcon,
    CreditsIcon,
    InformationIcon
  }
})
export default class Credits extends Vue {
  @Prop({ default: 0 }) credits!: number;

  private ActiveModal = new ActiveModal();

  get nameCredits() {
    return this.credits === 1
      ? this.$t('creditsComponent.credit')
      : this.$t('creditsComponent.credits');
  }

  handleRedirectStore() {
    this.$router.push({ name: 'Store' });
  }

  handleShowInformation() {
    this.ActiveModal.activeModal('ModalConsumerCredits');
  }
}
